import React from 'react';
import DatePicker from 'react-datepicker'

import "react-datepicker/src/stylesheets/datepicker.scss";
import "../../form.module.scss"

export default class FormikDatePicker extends React.Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      isDisabled: false,
    }
  }

  // enforce UTC to avoid awkward timezone issues
  formatDate = (value) => {
    const dateToString = value.toDateString() + " 00:00 UTC";
    const cleanDate = new Date(dateToString)
    return cleanDate.toISOString()
  }

  handleChange = value => {
    let cleanedValue = null;
    if (value && value.toDateString) {
      cleanedValue = this.formatDate(value)
    }
    this.props.form.setFieldValue(this.props.field.name, cleanedValue);
    if (this.props.setPreviousAddress) {
      this.props.setPreviousAddress(new Date(cleanedValue))
    }
  };

  changeIsDisabled = () => {
    this.setState({
      isDisabled: !this.state.isDisabled,
    });

    this.props.setDisableToParrent();


    if (!this.state.isDisabled) {
      const newDate = new Date;
      this.props.form.setFieldValue(this.props.field.name, this.formatDate(newDate));
    }

  }

  componentDidMount() {
    if (this.props.previousAddress) {
      this.props.form.setFieldValue(this.props.field.name, this.formatDate(this.props.previousAddress))
    }
  }


  render() {
    const { field, previousAddress, ...props } = this.props;

    return (
      <React.Fragment>
        <DatePicker
          dateFormat="dd/MM/yyyy"
          selected={
            typeof field.value === 'string'
              ? new Date(field.value)
              : this.props.selected || field.value
          }
          required={false}
          onChange={this.handleChange}
          showYearDropdown
          scrollableYearDropdown
          yearDropdownItemNumber={this.props.yearDropdownItemNumber || 65}
          disabled={this.state.isDisabled}
          {...props}
        />
        {
          // The logic with displaying the last element button only is in form.module.css
          this.props.setDisableToParrent &&
          <button
            className="btn-primary btn-helper date-picker-button"
            type="button"
            onClick={() => this.changeIsDisabled()}
          >
            {this.state.isDisabled ? 'Pick another address' : 'Currently lives here'}
          </button>
        }
      </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/modules/form/components/input/DatePicker.jsx